var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalSolicitarDeclaracao",
      attrs: {
        titulo: "Solicitar Declaração de trâmite processual",
        closeOutside: false
      },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "validation-observer",
            { ref: "observerDeclaracao" },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Motivo" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label:
                              "Informe a finalidade para solicitação da declaração de trâmite processual:"
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "select input select",
                            class: { erro: errors.length },
                            attrs: {
                              "value-key": "id",
                              name: "motivos",
                              placeholder: "Selecione",
                              clearable: "clearable"
                            },
                            model: {
                              value: _vm.motivoDeclaracao,
                              callback: function($$v) {
                                _vm.motivoDeclaracao = $$v
                              },
                              expression: "motivoDeclaracao"
                            }
                          },
                          _vm._l(_vm.motivos, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              staticClass: "selectOption",
                              attrs: { label: item.nome, value: item }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm.motivoDeclaracao &&
              _vm.motivoDeclaracao.nome.indexOf("Outro") === 0
                ? _c(
                    "div",
                    { staticClass: "container-input" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "Motivo" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "Qual outra finalidade?:" }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    model: {
                                      value: _vm.outroMotivo,
                                      callback: function($$v) {
                                        _vm.outroMotivo = $$v
                                      },
                                      expression: "outroMotivo"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2909681309
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "default" },
                on: {
                  click: function($event) {
                    return _vm.$emit("closeModal")
                  }
                }
              },
              [_vm._v("Cancelar")]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.gerar } },
              [_vm._v("Confirmar")]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-403c5a8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-403c5a8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/GerarDeclaracaoTramite.vue
// module id = null
// module chunks = 